// src\themes\lino\components\ProductBar.tsx
"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import ProductCard from "@/themes/lino/elements/Product/ProductCard";
import { MainShopProduct } from "@/core/models/shop-product-model";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { motion } from "motion/react";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { textGroupVariants, textItemVariants } from "./animations/textReveal";

// اگه تعداد محصولات کمتر یا مساوی این عدد باشه، دیگه به سوییپرِ
// اسکرول‌دار نیازی نیست: به‌جاش یه گرید می‌ذاریم که کارت‌ها
// به‌صورت درصدی از عرض رو پر می‌کنن و فضای خالی باقی نمی‌مونه.
const MAX_VISIBLE = 5;
const MIN_ITEM_WIDTH = 190;

export default function ProductBar({ data }: { data: MainShopProduct }) {
  const { dictionary } = useDictionary();
  const items = data.items || [];
  const useFluidGrid = items.length > 0 && items.length <= MAX_VISIBLE;

  return (
    <div className="col-span-12">
      <motion.div
        className="flex justify-between items-end mb-8 pb-5 border-b border-primary-200 max-md:flex-col max-md:items-start gap-2"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.4 }}
        variants={textGroupVariants}
      >
        <div className="space-y-1.5">
          <motion.h3 variants={textItemVariants} className="text-lg lg:text-xl font-light text-primary-900 tracking-tight">{data.title}</motion.h3>
          {data.description && (
            <motion.p variants={textItemVariants} className="text-[13px] text-primary-500">{data.description}</motion.p>
          )}
        </div>
        {data.link && (
          <motion.div variants={textItemVariants}>
            <Link className="text-[11px] uppercase tracking-[0.12em] text-primary-700 hover:text-primary-900 flex items-center gap-1.5 transition-colors" href={data.link}>
              {dictionary.ui?.pages.seeAll}
              <ArrowLeft className="stroke-[1.5] size-3.5 rtl:rotate-180" />
            </Link>
          </motion.div>
        )}
      </motion.div>

      {useFluidGrid ? (
        <div
          className="grid gap-5"
          style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${MIN_ITEM_WIDTH}px, 1fr))` }}
        >
          {items.map((item) => (
            <ProductCard key={item.id} product={item} />
          ))}
        </div>
      ) : (
        <Swiper
          modules={[Scrollbar]}
          spaceBetween={20}
          slidesPerView="auto"
          scrollbar={{ draggable: true, dragSize: 100 }}
          className="w-full"
          style={{ paddingBottom: "40px" }}
        >
          {items.map((item) => (
            <SwiperSlide key={item.id} style={{ width: "280px" }}>
              <ProductCard product={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}